// extracted by mini-css-extract-plugin
export default {"Dialog":"CreateTagDialog-module__Dialog__jKUZD4x"};